var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector81(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 341,
    height: 320,
    viewBox: "0 0 341 320",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M340.081 319.056C315.844 299.454 312.003 295.186 296.649 275.073C292.887 270.145 286.968 260.566 281.315 248.734C279.621 245.193 278.085 241.682 276.677 238.22C266.631 213.445 265.213 185.69 267.547 158.279C273.505 88.3406 235.648 25.2179 178.329 6.81612C120.902 -11.625 57.1528 18.6971 26.0413 66.0145C21.9936 72.1714 4.13821 101.225 1.4988 133.101C-6.8626 233.745 90.628 273.961 238.967 304.411C241.852 305.001 255.591 307.254 258.506 307.657L340.091 319.056H340.081Z",
    stroke: "#1E1E22",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector81);
export default __webpack_public_path__ + "static/media/vector8-1.d7d5e75efec0b9d721ed51234b0b67f7.svg";
export { ForwardRef as ReactComponent };